import { render } from "./RevolutionSection.vue?vue&type=template&id=3d14ff1f&scoped=true"
import script from "./RevolutionSection.vue?vue&type=script&lang=js"
export * from "./RevolutionSection.vue?vue&type=script&lang=js"

import "./RevolutionSection.vue?vue&type=style&index=0&id=3d14ff1f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d14ff1f"]])

export default __exports__